export var ORGS;
(function (ORGS) {
    ORGS["key"] = "key";
})(ORGS || (ORGS = {}));
//# sourceMappingURL=Organization.js.map